import React from "react";

/** Same look as the native controls of `CreateSubscriptionModal`. */
export const FIELD_CLASS =
	"w-full py-2 px-3 text-sm rounded-sm border border-semantic-border-secondary bg-semantic-bg-primary-alt text-semantic-text-primary";

/** Networking's notices state the zone; the forms say it the same way. */
const TIME_ZONE_HINT = "hora del centro de México (GMT-6)";

/** A `datetime-local` read in Mexico City time, whatever the operator's own zone. */
export function DateTimeField({
	id,
	label,
	value,
	onChange,
}: {
	id: string;
	label: string;
	value: string;
	onChange: (value: string) => void;
}) {
	return (
		<div className="flex flex-col space-y-2 min-w-0">
			<label htmlFor={id} className="text-sm font-medium text-semantic-text-primary">
				{label}
			</label>
			<input
				id={id}
				type="datetime-local"
				value={value}
				onChange={(event) => onChange(event.target.value)}
				className={FIELD_CLASS}
			/>
			<span className="text-xs text-semantic-text-secondary">{TIME_ZONE_HINT}</span>
		</div>
	);
}

/** Validation messages, shown once the operator has tried to save. */
export function FormErrors({ errors }: { errors: string[] }) {
	if (errors.length === 0) return null;
	return (
		<ul className="rounded-sm border border-semantic-border-danger-primary bg-semantic-bg-danger-secondary px-6 py-3 text-sm text-semantic-text-danger list-disc">
			{errors.map((message) => (
				<li key={message}>{message}</li>
			))}
		</ul>
	);
}

/** A failed request. */
export function RequestError({ message }: { message: string | null }) {
	if (!message) return null;
	return (
		<p className="rounded-sm border border-semantic-border-danger-primary bg-semantic-bg-danger-secondary px-4 py-3 text-sm text-semantic-text-danger">
			{message}
		</p>
	);
}
